<template>
  <div class="file-card-grid">
    <div class="grid-header">
      <span class="title">文件列表</span>
      <div class="toolbar">
        <el-input
          v-model="searchKeyword"
          placeholder="搜索文件名"
          prefix-icon="el-icon-search"
          clearable
          style="width: 260px"
        />
      </div>
    </div>

    <div class="cards-grid">
      <div v-for="(file, index) in planList" :key="index" class="card-item">
        <el-card
          :body-style="{ padding: '20px 16px' }"
          shadow="hover"
          class="file-card"
        >
          <div class="card-content">
            <div class="file-icon">
              <svg-component
                :icon-name="getFileIcon(file.name)"
              ></svg-component>
            </div>
            <div class="file-name" :title="file.name">
              {{ file.name }}
            </div>
            <div class="file-meta">
              <span class="file-size">{{
                file.uploadName ? file.uploadName : "庐鸣助手"
              }}</span>
            </div>
            <div class="file-actions">
              <el-button
                type="primary"
                size="small"
                plain
                @click="handleDownload(file)"
              >
                <i class="el-icon-download"></i> 下载
              </el-button>
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <div class="pagination-wrapper">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        @current-change="handleCurrentChange"
      />
    </div>
    <CodeDialogComponent
      :visible.sync="showPayDialog"
      :qr-text="qrText"
      @close="handleClosePayDialog"
    ></CodeDialogComponent>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SvgComponent from "../components/SvgComponent";
import { createNativePay, downloadCase } from "../api";
import CodeDialogComponent from "../components/CodeDialogComponent";
import { LOGIN_PATH } from "../utilis/enum";
import { WebSocketClient } from "../utilis";
export default {
  name: "Plan",
  components: { CodeDialogComponent, SvgComponent },
  data() {
    return {
      searchKeyword: "",
      pageSize: 20,
      currentPage: 1,
      showPayDialog: false,
      qrText: "",
    };
  },
  computed: {
    ...mapGetters("plan", ["planList", "total"]),
    ...mapGetters("user", ["userName"]),
  },
  methods: {
    ...mapActions("plan", ["selectCaseByPage"]),
    getFileIcon(fileName) {
      const ext = fileName.split(".").pop().toLowerCase();
      const iconMap = {
        pdf: "pdf",
        doc: "word",
        docx: "word",
        xls: "xlsx",
        xlsx: "xlsx",
        ppt: "ppt",
        pptx: "ppt",
      };
      return iconMap[ext] || "el-icon-document";
    },
    async handleDownload(file) {
      const response = await downloadCase(file.fileUrl, file.name);
      if (response.code === 4041 || response.code === 4042) {
        await this.$router.push(LOGIN_PATH);
        return;
      }

      if (response.code === 4043) {
        const payInfo = await createNativePay(100, "庐鸣数据一日会员");
        if (payInfo.code !== 200) return;
        this.qrText = payInfo.data;
        this.showPayDialog = true;
      }

      if (response.code === 200) {
        const downloadName = file.name;
        const link = document.createElement("a");
        link.href = response.data;
        link.download = downloadName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    async handleCurrentChange(page) {
      this.currentPage = page;
      await this.selectCaseByPage({
        fileName: this.searchKeyword,
        pageNum: this.currentPage,
      });
    },
    handleClosePayDialog() {
      this.showPayDialog = false;
    },
  },
  async mounted() {
    // 获取文件列表
    await this.selectCaseByPage({
      fileName: this.searchKeyword,
      pageNum: this.currentPage,
    });

    // 链接socket
    const wsClient = WebSocketClient.getInstance({
      baseUrl: "wss://www.gmxzf.cn/ws",
      params: { username: this.userName },
      heartbeatInterval: 15000,
    });

    wsClient.setCallbacks({
      onOpen: (event, client) => {
        console.log("连接成功，用户已认证");
        client.send({ type: "message", content: "Hello" });
      },
      onMessage: (data, event, client) => {
        console.log("收到消息:", data, event, client);
        const response = JSON.parse(data);

        if (response.code === 200 && response.data === "支付成功") {
          this.$message.success("支付成功");
          this.showPayDialog = false;
          this.qrText = "";
        }
      },
    });

    // 确保连接建立
    if (!wsClient.ws) {
      wsClient.connect();
    }

    // 保存 wsClient 实例到组件（方便后续使用）
    this.wsClient = wsClient;

    // 监听页面可见性变化
    this.handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        console.log("页面重新可见，检查 WebSocket 连接");
        if (this.wsClient) {
          this.wsClient.connect();
        }
      }
    };
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },

  destroyed() {
    this.wsClient.close();
  },
  watch: {
    searchKeyword() {
      this.currentPage = 1;
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/common/style/index";

.file-card-grid {
  background-color: $help_back_color;
  padding: $main_padding;
  border-radius: $main_border_radius;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;

  .grid-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .title {
      font-size: 18px;
      font-weight: bold;
      color: $main_font_color;
    }
  }

  .cards-grid {
    flex: 1;
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(4, 1fr);

    .card-item {
      width: 100%;
    }
  }

  .file-card {
    border-radius: 12px;
    transition: all 0.3s ease;
    border: 1px solid #ebeef5;
    height: 100%;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.15) !important;
    }

    .card-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      height: 100%;
    }

    .file-icon {
      font-size: 36px;
      color: $main_theme_color;
      margin-bottom: 10px;
      line-height: 1;
    }

    .file-name {
      font-size: 12px;
      font-weight: 500;
      color: $main_font_color;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 8px;
    }

    .file-meta {
      margin-bottom: 16px;

      .file-size {
        font-size: 10px;
        color: $help_font_color;
        background: $help_back_color;
        padding: 2px 10px;
        border-radius: 20px;
      }
    }

    .file-actions {
      width: 100%;
      margin-top: auto;

      .el-button {
        width: 100%;
        border-radius: 20px;
      }
    }
  }

  .pagination-wrapper {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
